import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#f98300',
        secondary: '#31649e',
        accent: '#4ea8bf',
        action: '#024690',
        error: '#b71c1c'
      }
    }
  }
})
